import axios from 'axios';
import * as Constants from "../common/constants";
import * as HelperFunctions from '../common/functions/helperFunctions';
import { DiseaseFilterSettingsModel, DiseaseAdminModel } from "../models/disease";
import AuthService from './authService';

class DiseaseService {
	authService = new AuthService();

	constructor() {
		axios.defaults.baseURL = `${Constants.apiUrl}/`;
		axios.defaults.headers = {
			"Content-Type": "application/json; charset=utf-8",
			Authorization: `Bearer ${this.authService.getToken()}`,
			Pragma: 'no-cache'
		}
	}

	getAllDiseases(from: number, numberOfRows: number, settings: DiseaseFilterSettingsModel) {
		return axios({
			url: `adminDisease/getAll/${from}/${numberOfRows}`,
			method: 'post', headers: {
				"Content-Type": "application/json; charset=utf-8"
			},
			data: JSON.stringify(settings)
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getDisease(id: number) {
		return axios({
			url: `adminDisease/getById/${id}`,
			method: 'get'
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	addDisease(medicine: DiseaseAdminModel) {
		return axios({
			url: `adminDisease/createDisease`,
			method: 'post',
			headers: {
				"Content-Type": "application/json; charset=utf-8"
			},
			data: JSON.stringify(medicine)
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	editDisease(id: number, medicine: DiseaseAdminModel) {
		return axios({
			url: `adminDisease/updateDisease/${id}`,
			method: 'put',
			headers: {
				"Content-Type": "application/json; charset=utf-8"
			},
			data: JSON.stringify(medicine)
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	deleteDisease(id: number) {
		return axios({
			url: `adminDisease/deleteDisease/${id}`,
			method: 'delete'
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getDropdownList() {
		return axios({
			url: `adminDisease/getDropdownList/`,
			method: 'get', headers: {
				"Content-Type": "application/json; charset=utf-8"
			}
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}
}

export default DiseaseService;
